module.exports = __webpack_public_path__ + "img/Patrick_Bradshaw_Headshot.5930f389.jpg";